import {
  defineSaleProgress,
  hasAddress,
  isSaleCreated,
  isSaleStarted,
  type ProgressSaleData,
  type SaleStatus,
} from '../saleProgress'
import type { ScriptSteps } from '../scripts/blocks/stages'

interface ProxiserveData extends ProgressSaleData {
  scriptSteps?: ScriptSteps | null
}

const PULSE = 'additionalSales:pulse.'

export const isSubscriptionLinkOpened = (data: ProxiserveData) => !!data.scriptSteps?.extLink

export default defineSaleProgress<ProxiserveData>({
  kind: 'sale',
  steps: [
    { key: 'address', label: `${PULSE}timeline.address`, done: hasAddress },
    { key: 'link_opened', label: `${PULSE}timeline.link_opened`, done: isSubscriptionLinkOpened },
    { key: 'created', label: `${PULSE}timeline.created`, done: isSaleCreated },
  ],
  status: (data, steps): SaleStatus => {
    if (steps[steps.length - 1]?.state === 'done') return 'signed'
    if (isSaleStarted(data) || steps.some(step => step.state === 'done')) return 'progress'

    return 'new'
  },
  doneLabel: `${PULSE}progress.sale_created`,
})
